export const removeProperties = <ObjectType, PropsArrayType extends string[]>(
  obj: ObjectType,
  props: PropsArrayType,
): ObjectType =>
  !obj || typeof obj !== 'object'
    ? obj
    : Array.isArray(obj)
      ? (obj.map((o) => removeProperties(o, props)) as ObjectType)
      : (Object.fromEntries(
          Object.entries(obj)
            .filter(([key]) => !props.includes(key))
            .map(([k, v]) => [k, removeProperties(v, props)]),
        ) as ObjectType);
